<!--
 * @Author: 陈芳 1441861445@qq.com
 * @Date: 2023-03-03 10:01:12
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-20 15:30:17
 * @FilePath: /seller.sviptrader.com/src/views/cooperationProgress/list/components/item/tipsLabel.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<span :class="['plain-tag yx-pingfang-regular mr-4 font-h6-regular', `plain-tag-${type}`, isMarginBottom ? 'mb-4' : '']">
		<slot></slot>
	</span>
</template>

<script>
export default {
	props: {
		type: {
			// primary || danger
			type: String,
			default: 'primary',
		},
		isMarginBottom: {
			type: Boolean,
			default: true,
		},
	},
};
</script>

<style lang="less" scoped>
.plain-tag {
	display: inline-flex;
	justify-content: center;
	border-radius: 3px;
	padding: 0px 3px;
	line-height: 16px;
	vertical-align: bottom;
}
.plain-tag-primary {
	border: 1px solid #f0f5ff;
	color: @color-primary;
}
.plain-tag-danger {
	border: 1px solid #ffeff3;
	color: @color-danger;
}
.plain-tag-warning {
	border: 1px solid #fff6f2;
	color: @color-warning;
}
.plain-tag-default {
	border: 1px solid #c9cdd4;
	color: @color-text-regular;
}
</style>
